exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/animate.css@3.5.1);", ""]);

// module
exports.push([module.id, "\n", ""]);

// exports
